/**
 * Display an inline error message next to input fields
 */
angular.module('qkr').directive('inputError', (utils, gettextCatalog) => {
    const linkFn = function(scope, element, attrs, ngModel) {
        // Set default display text
        scope.displayText = gettextCatalog.getString('There was an error with this field');

        // Override if provided
        if (scope.errorText) {
            scope.displayText = scope.errorText;
        }

        // Monitor errorObject for changes
        scope.$watch('errorObject', () => {
            if (!utils.isEmpty(scope.errorObject)) {
                if (scope.errorObject.hasOwnProperty(scope.errorKey)) {
                    scope.displayError = true;
                    scope.displayText = scope.errorObject[scope.errorKey];
                } else {
                    scope.displayError = false;
                }
            } else {
                scope.displayError = false;
            }
        });
    };

    return {
        link: linkFn,
        restrict: 'E',
        require: 'ngModel',
        replace: true,
        scope: {
            errorObject: '=ngModel',
            errorText: '@',
            errorKey: '@'
        },
        template: '<p class="ui-state-error-text" ng-show="displayError">{{displayText}}</p>'

    };
});



// WEBPACK FOOTER //
// ./src/directives/inputError.js